import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TakedMedicationDetailsComponent } from './taked-medication-details.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { AlertCommentDetailsModule } from '../../../alert/details/comment/details/alert-comment-details.module';

@NgModule({
  declarations: [TakedMedicationDetailsComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    AlertCommentDetailsModule
  ],
  exports: [TakedMedicationDetailsComponent]
})
export class TakedMedicationDetailsModule { }
